<script setup>
import { CSAT_TYPES } from 'shared/constants/messages';
import { computed } from 'vue';

const props = defineProps({
  selected: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update']);

const selectionClass = computed(() => {
  return props.selected
    ? 'bg-n-brand/5 outline-n-brand'
    : 'bg-n-alpha-black2 outline-n-weak';
});
</script>

<template>
  <button
    class="flex items-center rounded-lg transition-all duration-300 cursor-pointer outline outline-1 px-4 py-2 gap-2 min-w-56"
    :class="selectionClass"
    @click="emit('update', CSAT_TYPES.LINK_RESPONSE)"
  >
    <div class="flex items-center gap-2">
      <i class="i-ri-external-link-line text-n-brand text-xl" />
      <span class="text-sm font-medium text-n-slate-12">
        {{ $t('INBOX_MGMT.CSAT.TYPE.LINK_RESPONSE.TITLE') }}
      </span>
    </div>
  </button>
</template>
